import {
  HTTP_GETFORECASTLIST4_FETCHING,
  HTTP_GETFORECASTLIST4_SUCCESS,
  HTTP_GETFORECASTLIST4_FAILED,
  HTTP_RESET_FORECASTLIST4,
} from "../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETFORECASTLIST4_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETFORECASTLIST4_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETFORECASTLIST4_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    case HTTP_RESET_FORECASTLIST4:
      return initialState;
    default:
      return state;
  }
};
